<template>
  <div class="search-block-item">
    <div class="sch-form-item">
      <span v-if="portOrg == 2">{{ userInfo.orgName }}</span>
      <RemoteSelect
        v-if="portOrg != 2"
        v-model="schoolId"
        placeholder="请选择学校"
        :remote-method="remoteGetSchoolList"
        :loading="loadingSchool"
        @clear="remoteGetSchoolList('')"
        @visibleChange="loadAllList"
        @change="handleChange"
      >
        <el-option
          v-for="(item, index) in schoolIdList"
          :key="item.orgId + index"
          :label="item.name"
          :value="item.orgId"
        >
        </el-option>
      </RemoteSelect>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import operationAdmin from '@/request/operationAdmin/index.js';
import orderCenterApi from '@/request/orderCenter/index.js';
import RemoteSelect from '@c/RemoteSelect';
export default {
  computed: { ...mapState(['userInfo']) },
  components: {
    RemoteSelect
  },
  props: {
    // 是否需要缓存回填
    cacheSchoolId: {
      type: String,
      default: ''
    },
    cacheSchoolName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingSchool: false,
      schoolIdList: [{ orgId: -1, name: '请选择学校' }], // 学校
      portOrg: localStorage.getItem('portOrg'),
      schoolId: -1
    };
  },
  created() {
    this.init();
  },
  methods: {
    getResult() {
      return {
        schoolId: this.schoolId
      };
    },
    clear() {
      this.schoolId = '';
      this.remoteGetSchoolList('');
    },
    init() {
      // 学校端
      if (this.portOrg == 2) {
        this.schoolId = this.userInfo.orgId;
        this.$emit('on-change', {
          schoolId: this.userInfo.orgId,
          schoolName: this.userInfo.orgName
        });
      } else {
        if (this.cacheSchoolId && this.cacheSchoolName) {
          this.initCache();
        } else {
          this.getgoodSchoolListFun();
        }
      }
    },
    initCache() {
      this.schoolId = this.cacheSchoolId;
      this.schoolIdList = [
        { orgId: -1, name: '请选择学校' },
        { orgId: this.cacheSchoolId, name: this.cacheSchoolName }
      ];
      console.log(1111);
    },
    remoteGetSchoolList(queryTrue) {
      this.getgoodSchoolListFun(queryTrue);
    },
    loadAllList(val) {
      if (!val) {
        this.remoteGetSchoolList('');
      }
    },
    // 内容
    handleChange(id) {
      this.$emit('on-change', {
        schoolId: id,
        schoolName: this.getSchoolName(id)
      });
    },
    getSchoolName(id) {
      const key = this.schoolIdList.findIndex(item => { return item.orgId == id; });
      return this.schoolIdList[key]['name'];
    },
    // 搜索框 学校列表
    async getgoodSchoolListFun(searchStr) {
      const params = {
        pageNum: 1,
        pageSize: 20,
        searchStr

      };
      let res;
      if (this.portOrg == 3) {
        const userInfo = localStorage.getItem('userInfo');
        params.orgId = JSON.parse(userInfo).orgId;
        // 运营端,教育局 机构端
        res = await operationAdmin.getOrgSchoolsNew(params);
      } else if (this.portOrg == 1) {
        res = await orderCenterApi.getSchoolsList(params);
      } else {
        // 运营端,教育局
        res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
      }
      this.loadingSchool = false;
      if (res.status === 200) {
        if (this.portOrg == 3) {
          this.schoolIdList = [
            { orgId: -1, name: '请选择学校' },
            ...res.message.map(item => {
              return { orgId: item.schoolId, name: item.schoolName };
            })
          ];
        } else {
          this.schoolIdList = [
            { orgId: -1, name: '请选择学校' },
            ...res.message.list.map(item => {
              return { orgId: item.orgId, name: item.name };
            })
          ];
        }
      }
    },
    handleClear() {
      this.schoolId = -1;
    }
  }
};
</script>

<style>
</style>
